export default __webpack_public_path__ + "static/media/FACEBOOK.8373cffb.png";